import { createElement } from 'react';
import { StatusTag } from '@paysera/ui';
import formatAmount from '@modules/calculator/utils/formatAmount';
import { getFundingProgress } from './getFundingProgress';
import { getInvestmentStatusVariant } from './getInvestmentStatusVariant';
const renderStatusValue = (status, label) => {
    const variant = getInvestmentStatusVariant(status);
    if (!variant) {
        return label;
    }
    return createElement(StatusTag, { variant, label, isFilledIcon: false });
};
export const getInvestmentRows = (investment, t) => [
    {
        key: 'id',
        label: t('financing.investing_page_table.id'),
        value: investment.id,
    },
    {
        key: 'loanAmount',
        label: t('financing.investing_page_table.asked_amount'),
        value: `${formatAmount(investment.loanAmount, true, false)} ${investment.loanCurrency}`,
    },
    {
        key: 'loanPurpose',
        label: t('financing.investing_page_table.loan_purpose'),
        value: investment.loanPurpose,
    },
    {
        key: 'loanPeriod',
        label: t('financing.investing_page_table.period'),
        value: `${investment.loanPeriod} ${t('financing.investing_page_table.months')}`,
    },
    {
        key: 'roi',
        label: t('financing.investing_page_table.roi'),
        value: `${investment.roi}%`,
    },
    {
        key: 'fundingProgress',
        label: t('financing.investing_page_table.funding_progress'),
        value: getFundingProgress(investment),
    },
    {
        key: 'status',
        label: t('financing.investing_page_table.status'),
        value: renderStatusValue(investment.investmentStatus, t(`financing.loan_status.${investment.investmentStatus.toLowerCase()}`)),
    },
];
